export const UNIT_MOVEMENT_DURATION_MS = 400;

// Сколько сверх длительности перехода проигрыватель записи матча готов ждать
// двойника отряда (см. HexGridRenderer.showUnitMovementFlight): кадры в скрытой
// вкладке не идут, переход может зависнуть — и запись встала бы вместе с ним
export const UNIT_MOVEMENT_WAIT_MARGIN_MS = 1000;
